import _styled, { default as _styled2 } from "styled-components";
import { FooterLink } from "~/features/app/app-footer/footer-links/footer-link";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
export const fragment = graphql(`
  fragment FooterGroup on footerLinks_group_BlockType {
    title: baseText
    links: children {
      ...FooterLink
    }
  }
`);
export function FooterGroup(props: FragmentType<typeof fragment>) {
  const {
    title,
    links
  } = useFragment(fragment, props);
  return <div>
      <_StyledP>
        {title}
      </_StyledP>
      <_StyledUl>
        {links?.map((link, idx) => <li key={idx}>
            <FooterLink {...link} />
          </li>)}
      </_StyledUl>
    </div>;
}
var _StyledP = _styled("p").withConfig({
  componentId: "sc-sf-1n5olpl-0"
})({
  "marginBottom": "2.4rem",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "--tw-text-opacity": "1",
  "color": "rgb(92 92 92 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "marginBottom": "4rem",
    "fontSize": "1.4rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400"
  }
});
var _StyledUl = /*#__PURE__*/_styled2("ul").withConfig({
  displayName: "footer-group___StyledUl",
  componentId: "sc-1mb8b8q-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "rowGap": "2.4rem"
});